export const FavoritesActionType = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  SYNC_FAILURE: 'UPDATE_FAILURE',
  SYNC_SUCCESS: 'UPDATE_SUCCESS',
  SYNC_LIST: 'SYNC_LIST'
}
